ACC.carousel = {
  _autoload: [
    ['bindCarousel', $('.js-owl-carousel').length > 0],
    'bindJCarousel'
  ],

  carouselConfig: {
    default: {
      navigation: true,
      navigationText: [
        '<span class="svg-icon_chevron_left svg-icon_chevron_left-dims"></span>',
        '<span class="svg-icon_chevron_right svg-icon_chevron_right-dims"></span>'
      ],
      pagination: false,
      itemsCustom: [
        [0, 1],
        [768, 2],
        [1024, 2],
        [1400, 3]
      ]
    },
    'rotating-image': {
      navigation: false,
      pagination: true,
      singleItem: true
    },
    'lazy-reference': {
      navigation: true,
      navigationText: [
        '<span class="svg-icon_chevron_left svg-icon_chevron_left-dims"></span>',
        '<span class="svg-icon_chevron_right svg-icon_chevron_right-dims"></span>'
      ],
      pagination: false,
      itemsDesktop: [5000, 3],
      itemsDesktopSmall: [1200, 2],
      itemsTablet: [768, 2],
      itemsMobile: [375, 0],
      lazyLoad: true
    }
  },

  bindCarousel: function() {
    $('.js-owl-carousel').each(function() {
      var $c = $(this);
      $.each(ACC.carousel.carouselConfig, function(key, config) {
        console.log(config);
        if ($c.hasClass('js-owl-' + key)) {
          var $e = $(document).find('.js-owl-' + key);
          if ($('.js-owl-carousel').hasClass('js-owl-three')) {
            config.itemsDesktop = [5000, 3];
            config.itemsDesktopSmall = [1200, 2];
            config.itemsTablet = [768, 2];
            config.itemsMobile = [375, 1];
          }
          $e.owlCarousel(config);
          $('.custom-owl-prev').on('click', () => {
            $('.owl-prev').trigger('owl.prev');
          });
          $('.custom-owl-next').on('click', () => {
            $('.owl-next').trigger('owl.next');
          });
        }
      });
    });
  },

  bindJCarousel: function() {
    $('.modal').colorbox({
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    $('.svw').each(function() {
      $(this).waitForImages(function() {
        $(this).slideView({
          toolTip: true,
          ttOpacity: 0.6,
          autoPlay: true,
          autoPlayTime: 8000
        });
      });
    });
    
    
    $('.rotating-slider').each(function(){
		let slider = $(this).find("ul").bxSlider({
		  autoControls: true,
		  auto: true,
		  pager: false,
		  mode: "horizontal",
		  captions: false,
		  slideMargin:1,
		  speed: 1000,
		  pause:10000,
		  onSlideAfter: function() {
            slider.startAuto();
          }
		});
	})
    
  }
};
